import * as React from 'react';
import { useFela } from 'react-fela';
import { Link } from 'react-router-dom';

import type { IStyle } from 'fela';

import { getIconClass } from '../utils/icon-class';
import { Box } from './generic/box/box';
import * as styles from './TagCard.style';

import type { PublicTag, Theme } from '../types';

interface Props {
  tag: PublicTag;
  to: string;
  style?: IStyle;
}

// One card for both levels: a section on the front page and a topic on a
// section page.
const TagCard = ({ tag, to, style = {} }: Props): React.ReactElement => {
  const { theme } = useFela<Theme>();

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Box style={{ ...styles.card(theme), ...style }} className="kb-section-card">
        <Box as="span" style={styles.icon(theme)} className="kb-section-card__icon">
          <i className={getIconClass(tag.icon)} />
        </Box>
        <Box style={styles.body} className="kb-section-card__body">
          <Box as="span" style={styles.title(theme)} className="kb-section-card__title">
            {tag.name}
          </Box>
          {!!tag.description && (
            <Box as="span" style={styles.description} className="kb-section-card__description">
              {tag.description}
            </Box>
          )}
        </Box>
        <Box as="span" style={styles.chevron} className="kb-section-card__chevron">
          <i className="fa fa-chevron-right" />
        </Box>
      </Box>
    </Link>
  );
};

export default TagCard;
